import { FC, Dispatch, SetStateAction, createContext, useCallback, useMemo, useState } from 'react'
import { fabric } from 'fabric'
import EditorEventManager from '../EditorEventManager'
import { ContextMenuAnchor } from '../common/constants'

export interface IEditorContext {
  canvas: fabric.Canvas | null
  setCanvas: Dispatch<SetStateAction<fabric.Canvas | null>>
  activeObject: fabric.Object | null
  setActiveObject: (object: fabric.Object | null) => void
  editor: EditorEventManager | null
  setEditor: Dispatch<SetStateAction<EditorEventManager | null>>
  contextMenuAnchor: ContextMenuAnchor
  setContextMenuAnchor: (value: ContextMenuAnchor) => void
}

export const EditorContext = createContext<IEditorContext>({
  canvas: null,
  setCanvas: (() => {}) as Dispatch<SetStateAction<fabric.Canvas | null>>,
  activeObject: null,
  setActiveObject: () => {},
  editor: null,
  setEditor: (() => {}) as Dispatch<SetStateAction<EditorEventManager | null>>,
  contextMenuAnchor: null,
  setContextMenuAnchor: (value: ContextMenuAnchor) => {},
})

export const EditorProvider: FC = ({ children }) => {
  const [canvas, setCanvas] = useState<fabric.Canvas | null>(null)
  const [activeObject, _setActiveObject] = useState<fabric.Object | null>(null)
  const [editor, setEditor] = useState<EditorEventManager | null>(null)
  const [contextMenuAnchor, setContextMenuAnchor] = useState<ContextMenuAnchor>(null)

  const setActiveObject = useCallback((object: fabric.Object | null) => {
    _setActiveObject(object)
  }, [])

  const context = useMemo(() => ({
    canvas,
    setCanvas,
    activeObject,
    setActiveObject,
    editor,
    setEditor,
    contextMenuAnchor,
    setContextMenuAnchor,
  }), [canvas, activeObject, editor, contextMenuAnchor, setActiveObject])

  return <EditorContext.Provider value={context}>{children}</EditorContext.Provider>
}
